export function loginDestination(search: string): string {
  const target = new URLSearchParams(search).get('returnTo')
  if (!target || !target.startsWith('/') || target.startsWith('//') ||
    /[\\\s]/.test(target) || target.split('?')[0] === '/login') return '/dashboard'
  return target
}

export function loginUrl(path: string): string {
  if (path === '/login' || path.startsWith('/login?')) return path
  return `/login?returnTo=${encodeURIComponent(path)}`
}
